import { useStore } from 'effector-react'
import { $section, sectionListForSelectMounted } from './model'
import { useLayoutEffect } from 'react'

export const useCreateSection = () => {
  const section = useStore($section)

  useLayoutEffect(() => {
    sectionListForSelectMounted()
  }, [])

  return { section }
}
